import React from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';

import { Link } from 'core/routing';

import { Wizard } from 'libs/wizards/index';
import DocumentHead from 'legacyComponents/documentHead';

import { clientStore } from 'apps/client/app';
import { SignUpAppManager } from 'apps/profile/signUp/appManager';

import { withNamespaces } from 'react-i18next';

import { Button } from 'components';

import {
  MainSignInPageWrapper,
  GoBackWrapper,
  WrapperSignInForm,
  MainSignInFormColumn,
} from 'apps/signIn/styles';

import Logo from 'components/Logo';
import { analytics } from 'core/analytics';

import SignUpInformation from './SignUpInformation';

@inject('routerStore')
@withNamespaces()
@observer
export class SignUp extends React.Component {
  UNSAFE_componentWillMount() {
    if (clientStore.signedInProfile) {
      clientStore.routerStore.navigate('home');
    }
    this.appManager = new SignUpAppManager(null, this.props);
    const username = this.props.params.get('username');
    const email = this.props.params.get('email');
    const password = this.props.params.get('password');
    if (username) {
      this.appManager.signUpApp.user.username = username;
    }
    if (email) {
      this.appManager.signUpApp.user.email = email;
    }
    if (password) {
      this.appManager.signUpApp.user.password = password;
      clientStore.routerStore.params.set('password', '');
    }
    if (username && email && password) {
      this.appManager.signUpApp.wizard.Next();
    }

    if (clientStore.routerStore.path === '/sign-up?next=%2Fmake-part') {
      analytics.sendEvent(
        'AddToWishlist',
        { value: 12, currency: 'EUR' },
        { facebook: true },
      );
    }
  }

  render() {
    const { t } = this.props;
    return (
      <>
        <DocumentHead title={`${t('Sign up')}`} index='noindex' />
        <MainSignInPageWrapper>
          <GoBackWrapper>
            <Button
              outline
              variant='minimal'
              icon='close_small'
              size='small'
              onClick={() => window.history.go(-1)}
            />
          </GoBackWrapper>
          <SignUpInformation />
          <WrapperSignInForm>
            <MainSignInFormColumn>
              <Link name='home'>
                <Logo size='48px' />
              </Link>
              <Wizard
                isSideBarForm
                spacing='medium'
                wizard={this.appManager.signUpApp.wizard}
              />
            </MainSignInFormColumn>
          </WrapperSignInForm>
        </MainSignInPageWrapper>
      </>
    );
  }
}

SignUp.propTypes = {
  t: PropTypes.func,
  params: PropTypes.object,
};
